<template>
  <div style="height: 100%; overflow-y: auto; padding: 0 4px;">
    <!-- ================= 默认分账规则(基础表,只读) ================= -->
    <div class="zone">
      <div class="zone-header">
        <span class="zone-bar"></span>
        <span class="zone-title">默认分账规则</span>
        <span class="zone-desc">当前未配置商户统一按<b style="color:#E6A23C;">普票列</b>结算 · 商户票种暂不参与计算 · 参与分账基准 = 专票6%列</span>
      </div>
      <div class="tablecss" v-loading="tableLoading" element-loading-background="rgba(255, 255, 255, 0.9)"
        element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" custom-class="table-loading">
        <div style="width: 100%">
          <ve-table ref="vetable" :columns="columns" :table-data="tableData" :max-height="200"
            :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
            style="width: 100%" />
          <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
        </div>
      </div>
    </div>

    <!-- ================= 商户分账绑定(覆盖规则) ================= -->
    <div class="zone">
      <div class="zone-header">
        <span class="zone-bar"></span>
        <span class="zone-title">商户分账绑定</span>
        <span class="zone-desc">按商户+档位直接配置实得金额,优先于默认规则,不按票种折减</span>
      </div>
      <el-row class="filter-bar" ref="filterBar" style="padding: 6px 0 10px;">
        <el-input v-model="cmForm.asName" style="width: 200px;" size="mini" placeholder="商户名称搜索" clearable
          @keyup.enter.native="cmSearch" @clear="cmSearch"></el-input>
        <el-button type="info" size="mini" icon="el-icon-search" @click="cmSearch">搜索</el-button>
        <el-button type="primary" size="mini" icon="el-icon-plus" @click="cmOpenAdd">新增绑定</el-button>
      </el-row>
      <div class="tablecss" v-loading="cmTableLoading" element-loading-background="rgba(255, 255, 255, 0.9)"
        element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" custom-class="table-loading">
        <div style="width: 100%">
          <ve-table ref="cmvetable" :columns="cmColumns" :table-data="cmTableData" :max-height="cmTableHight"
            :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
            style="width: 100%" />
          <div v-show="cmTableData.length == 0" class="empty-data">暂无数据</div>
        </div>
        <div class="table-pagination">
          <ve-pagination :total="cmTotalCount" :page-index="cmPage.currentPage" :page-size="cmPage.pageSize"
            :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]" @on-page-number-change="cmPageNumberChange"
            @on-page-size-change="cmPageSizeChange" />
        </div>
      </div>
    </div>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="cmDialog.asocId ? '编辑商户分账绑定' : '新增商户分账绑定'" :visible.sync="cmDialogVisible"
      width="440px" :close-on-click-modal="false" top="18vh">
      <el-form label-width="80px" size="mini" label-position="right">
        <el-form-item label="商户" required>
          <el-select v-model="cmDialog.asId" filterable placeholder="输入名称/ID搜索选择商户" style="width: 100%"
            :disabled="!!cmDialog.asocId">
            <el-option v-for="item in shopOptions" :key="item.asId" :label="item.asId + ' - ' + item.asName"
              :value="item.asId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="档位金额" required>
          <el-select v-model="cmDialog.asocAmountYuan" placeholder="选择档位" style="width: 100%"
            :disabled="!!cmDialog.asocId">
            <el-option label="120元" value="120"></el-option>
            <el-option label="240元" value="240"></el-option>
            <el-option label="360元" value="360"></el-option>
            <el-option label="480元" value="480"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分账金额" required>
          <el-input v-model="cmDialog.asocCommissionYuan" placeholder="单位元,如 70 或 65.5" style="width: 100%"
            @input="e => cmDialog.asocCommissionYuan = e.replace(/[^\d.]/g, '')">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-tip">该金额为商户实得,保存后该商户该档位分账直接按此金额执行(不按票种折减);同商户同档位再次保存即为改价。</div>
      <div slot="footer">
        <el-button size="mini" @click="cmDialogVisible = false">取 消</el-button>
        <el-button type="primary" size="mini" :loading="cmSaving" @click="cmSave">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { calcTableHeight } from "../../utils/tableHeight.js";
import { getAjefShopOrderRatioList, getAjefShopOrderCommissionList, updateAjefShopOrderCommission, deleteAjefShopOrderCommission, getAjefShopListQuick } from "../../api/api";
export default {
  name: "ShopOrderRatio",
  components: {},
  data() {
    return {
      watchFlag: false,
      windheight: 0,
      // ===== 默认规则(基础表,只读) =====
      tableLoading: false,
      tableData: [],
      columns: [
        {
          field: "",
          key: "a",
          title: "序号",
          width: 60,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return ++rowIndex;
          },
        },
        {
          field: "asoRatioAmountYuan",
          key: "asoRatioAmountYuan",
          title: "档位金额",
          width: 140,
          align: "center",
          renderBodyCell: ({ row }, h) => {
            return h('span', { class: 'tier-text' }, row.asoRatioAmountYuan + '元');
          },
        },
        {
          field: "asoRatioSign1Yuan",
          key: "asoRatioSign1Yuan",
          title: "专票6%",
          width: 130,
          align: "center",
          renderBodyCell: ({ row }) => {
            return row.asoRatioSign1Yuan != null && row.asoRatioSign1Yuan !== "" ? row.asoRatioSign1Yuan + "元" : "-";
          },
        },
        {
          field: "asoRatioSign2Yuan",
          key: "asoRatioSign2Yuan",
          title: "专票3%",
          width: 130,
          align: "center",
          renderBodyCell: ({ row }) => {
            return row.asoRatioSign2Yuan != null && row.asoRatioSign2Yuan !== "" ? row.asoRatioSign2Yuan + "元" : "-";
          },
        },
        {
          field: "asoRatioSign3Yuan",
          key: "asoRatioSign3Yuan",
          title: "专票1%",
          width: 130,
          align: "center",
          renderBodyCell: ({ row }) => {
            return row.asoRatioSign3Yuan != null && row.asoRatioSign3Yuan !== "" ? row.asoRatioSign3Yuan + "元" : "-";
          },
        },
        {
          field: "asoRatioSign4Yuan",
          key: "asoRatioSign4Yuan",
          title: "普票",
          width: 130,
          align: "center",
          renderBodyCell: ({ row }, h) => {
            return h('span', { class: 'money-strong' }, row.asoRatioSign4Yuan + '元');
          },
        },
        {
          field: "note",
          key: "note",
          title: "说明",
          align: "left",
          renderBodyCell: ({ row }) => {
            return "当前默认按普票列结算;参与分账基准 " + row.asoRatioAmountBillYuan + " 元(专票6%列)";
          },
        },
      ],
      // ===== 商户分账绑定 =====
      cmTableLoading: false,
      cmTableData: [],
      cmTotalCount: 0,
      cmTableHight: 320,
      cmForm: { asName: "" },
      cmPage: { currentPage: 1, pageSize: 10 },
      cmDialogVisible: false,
      cmSaving: false,
      cmDialog: { asocId: null, asId: null, asocAmountYuan: "", asocCommissionYuan: "" },
      shopOptions: [],
      cmColumns: [
        {
          field: "",
          key: "a",
          title: "序号",
          width: 60,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return ++rowIndex;
          },
        },
        { field: "asId", key: "asId", title: "商户ID", width: 80, align: "center" },
        {
          field: "asName",
          key: "asName",
          title: "商户名称",
          align: "left",
          renderBodyCell: ({ row }) => {
            return row.asName || "-";
          },
        },
        {
          field: "asocAmountYuan",
          key: "asocAmountYuan",
          title: "档位金额",
          width: 110,
          align: "center",
          renderBodyCell: ({ row }, h) => {
            return h("el-tag", { props: { size: "mini" } }, row.asocAmountYuan + "元档");
          },
        },
        {
          field: "asocCommissionYuan",
          key: "asocCommissionYuan",
          title: "分账金额",
          width: 110,
          align: "center",
          renderBodyCell: ({ row }, h) => {
            return h('span', { class: 'money-strong' }, row.asocCommissionYuan + '元');
          },
        },
        {
          field: "asocBaseCommissionYuan",
          key: "asocBaseCommissionYuan",
          title: "默认实得(普票)",
          width: 130,
          align: "center",
          renderBodyCell: ({ row }, h) => {
            if (row.asocBaseCommissionYuan == null || row.asocBaseCommissionYuan === "") {
              return "-";
            }
            return h('span', { class: 'money-muted' }, row.asocBaseCommissionYuan + '元');
          },
        },
        { field: "createusername", key: "createusername", title: "操作人", width: 90, align: "center" },
        { field: "updatetime", key: "updatetime", title: "更新时间", width: 155, align: "center" },
        {
          field: "",
          key: "operation",
          title: "操作",
          align: "center",
          width: 110,
          fixed: 'right',
          renderBodyCell: ({ row }, h) => {
            return h('div', [
              h('el-button', {
                props: { type: 'text', size: 'mini' },
                on: { click: () => this.cmOpenEdit(row) }
              }, '编辑'),
              h('el-button', {
                props: { type: 'text', size: 'mini' },
                style: { color: '#F56C6C' },
                on: { click: () => this.cmDelete(row) }
              }, '删除')
            ]);
          },
        },
      ],
      cellStyleOption: {
        headerCellClass: ({ column, rowIndex }) => {
          if (rowIndex === 0) {
            return "table-header-cell-class";
          }
        },
      },
    };
  },
  activated() {
    this.watchFlag = true;
    this.$nextTick(() => {
      this.windheight = this.$store.state.windheight;
      this.calcHeights();
    });
  },
  watch: {
    "$store.state.windheight"(val) {
      this.$nextTick(() => {
        if (this.watchFlag) {
          this.calcHeights(val);
        }
      });
    },
  },
  mounted() {
    this.getList();
    this.cmGetList();
    this.loadShops();
  },
  methods: {
    calcHeights(val) {
      //默认规则区约280px,商户绑定表占剩余
      const full = calcTableHeight(this, val || this.windheight, 140);
      this.cmTableHight = Math.max(full - 330, 200);
    },
    // ===== 默认规则(基础表) =====
    getList() {
      this.tableLoading = true;
      getAjefShopOrderRatioList({ currentPage: 1, pageSize: 10 }).then((res) => {
        this.tableLoading = false;
        this.tableData = res.data || [];
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    // ===== 商户分账绑定 =====
    loadShops() {
      if (this.shopOptions.length === 0) {
        getAjefShopListQuick({ pageSize: 0 }).then(res => {
          this.shopOptions = res.data || [];
        });
      }
    },
    cmGetList() {
      this.cmTableLoading = true;
      const params = Object.assign({}, this.cmPage, { asName: this.cmForm.asName || null });
      getAjefShopOrderCommissionList(params).then((res) => {
        this.cmTableLoading = false;
        this.cmTableData = res.data || [];
        this.cmTotalCount = res.total || 0;
      }).catch(() => {
        this.cmTableLoading = false;
      });
    },
    cmSearch() {
      this.cmPage.currentPage = 1;
      this.cmGetList();
    },
    cmPageNumberChange(pageIndex) {
      this.cmPage.currentPage = pageIndex;
      this.cmGetList();
    },
    cmPageSizeChange(pageSize) {
      this.cmPage.pageSize = pageSize;
      this.cmGetList();
    },
    cmOpenAdd() {
      this.loadShops();
      this.cmDialog = { asocId: null, asId: null, asocAmountYuan: "", asocCommissionYuan: "" };
      this.cmDialogVisible = true;
    },
    cmOpenEdit(row) {
      this.loadShops();
      this.cmDialog = {
        asocId: row.asocId,
        asId: row.asId,
        asocAmountYuan: row.asocAmountYuan,
        asocCommissionYuan: row.asocCommissionYuan,
      };
      this.cmDialogVisible = true;
    },
    cmSave() {
      if (!this.cmDialog.asId) {
        this.$message.warning("请选择商户");
        return;
      }
      if (!this.cmDialog.asocAmountYuan) {
        this.$message.warning("请选择档位金额");
        return;
      }
      if (!this.cmDialog.asocCommissionYuan || parseFloat(this.cmDialog.asocCommissionYuan) <= 0) {
        this.$message.warning("请填写大于0的分账金额");
        return;
      }
      this.cmSaving = true;
      updateAjefShopOrderCommission({
        asId: this.cmDialog.asId,
        asocAmountYuan: this.cmDialog.asocAmountYuan,
        asocCommissionYuan: this.cmDialog.asocCommissionYuan,
      }).then(() => {
        this.cmSaving = false;
        this.$message.success("保存成功");
        this.cmDialogVisible = false;
        this.cmGetList();
      }).catch(() => {
        this.cmSaving = false;
      });
    },
    cmDelete(row) {
      this.$confirm('删除后 ' + (row.asName || row.asId) + ' 的' + row.asocAmountYuan + '元档位回退默认规则(按票种折减),确认删除?', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteAjefShopOrderCommission({ asocId: row.asocId }).then(() => {
          this.$message.success("已删除");
          this.cmGetList();
        });
      }).catch(() => { });
    },
  },
};
</script>

<style scoped>
.zone {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  padding: 10px 12px 12px;
  margin-bottom: 14px;
}

.zone-header {
  display: flex;
  align-items: center;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f2f5;
  margin-bottom: 10px;
}

.zone-bar {
  display: inline-block;
  width: 4px;
  height: 16px;
  border-radius: 2px;
  background: #409eff;
  margin-right: 8px;
}

.zone-title {
  font-size: 15px;
  font-weight: bold;
  color: #303133;
  margin-right: 12px;
  white-space: nowrap;
}

.zone-desc {
  font-size: 12px;
  color: #909399;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>

<style>
/* ve-table单元格内通用强调样式(非scoped,renderBodyCell的h()不经过scoped编译) */
.tier-text {
  font-weight: bold;
  color: #303133;
}

.money-strong {
  font-weight: bold;
  color: #f56c6c;
}

.money-muted {
  color: #909399;
}
</style>
